export default "__VITE_PUBLIC_ASSET__5de5c4ff__"